import Base from './base'

export default class PushSubscription extends Base {
  subscribe(data: object) {
    return this.apiClient.post('push-subscriptions', data)
  }

  unsubscribe(data: object) {
    return this.apiClient.delete('push-subscriptions', data)
  }
}
